// 3rd party libraries
import React, { useEffect, useState, useRef } from 'react';
import { I18n } from 'aws-amplify';
import { Tooltip, Box, Button } from '@material-ui/core';

// Utils, constant
import Utils from '@/common/utils/utils';
import Constant from '../../../common/constant/Constant';

// Component
import MermaidDiagram from './MermaidDiagram';
import FormInputWithOnChange from '@/component/common/form/input-with-onchange';

export default function MermaidFieldUI(props) {
    const publicForCustomer = props.data.structure.publicForCustomer;

    const handleOnApply = () => {
        if (!props?.errorlist.hasOwnProperty(props?.name)) {
            setIsShowDiagram(true);
        }
    }

    const handleOnReset = () => {
        props?.clearErrors(props?.name);
        let oldValue = defaultValue;
    
        props?.setValue(props?.name, oldValue);
        setValueMermaid(oldValue);
        setIsShowDiagram(true);
    }
    const getDefaultValue = () => {
        return props?.defaultValue || '';
    }
    const handleOnclickEdit = () => {
        setIsShowDiagram(false);
    }

    const onChangeMermaidValue = e => {
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            if (!props?.listFieldEdited?.includes(props?.name)) {
                props?.setListFieldEdited([...props.listFieldEdited, props?.name]);
            }
            if (props?.setOnChangeEdit) {
                props?.setOnChangeEdit(!props.onChangeEdit);
            }
        }
        setValueMermaid(e.target.value);
    };

    const onChangeValueMermaidInput = e => {
        onChangeMermaidValue(e);
    };

    const defaultValue = getDefaultValue();
    const [valueMermaid, setValueMermaid] = useState(defaultValue);
    const [isShowDiagram, setIsShowDiagram] = useState(true);

    const updatedAt = props?.detailTicket?.updatedAt;
    const notError = !props?.errorlist.hasOwnProperty(props?.name);
    const isAddTicket = !props?.detailTicket || false;
    const isEditTicket = !isAddTicket;

    const isNotEditMermaid =
        publicForCustomer == Constant.SETTING_FORM_DEFAULT.READ_ONLY
        || props.viewFromProjectOfEscalateTicket
        || !Utils.isEmptyString(props.detailTicket?.deletedAt)
        || props.hasEditFieldPermissions === false;

    useEffect(() => {
        setIsShowDiagram(isEditTicket);
    }, []);

    useEffect(() => {
        setIsShowDiagram(notError && isEditTicket);
    }, [updatedAt]);

    useEffect(() => {        
        let isKnowledgeForm = [Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(props?.parentForm?.type);
        if (isAddTicket || props?.isDraftMode || (props?.editTicket && !isKnowledgeForm)) {
            props.register(props?.name, {
                onChange: e => {}
            });
        
            props.setValue(props?.name, defaultValue || '');
            setValueMermaid(defaultValue || '');
        }
    }, [props?.parentForm]);

    useEffect(() => {
        if (props?.flagReset) {
            handleOnReset();
            props.setFlagReset(false);
        }
    }, [props?.flagReset]);

    const showBoxDiagram = (isNotEditMermaid || isShowDiagram);
    return (
        <div className="form-addTicket field-">
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? (
                    <div className="d-flex">
                        <Tooltip title={props?.label}>
                            <span className="form-addTicket-label text-truncate">
                                <label
                                    className={
                                        `text-truncate line-height-18 w-f100 ${
                                            (publicForCustomer
                                                ? 'form-addTicket-label-color'
                                                : 'form-addTicket-label')
                                        }`
                                    }
                                >
                                    {props?.label}
                                </label>
                            </span>
                        </Tooltip>
                        {props.data.structure.required && (
                            <span className="required padding-left-4">*</span>
                        )}
                    </div>
                ) : (
                    <label
                        className={
                            `w-f100 ${
                            publicForCustomer
                                ? 'form-addTicket-label-color'
                                : 'form-addTicket-label'
                            }`
                        }
                    >
                        {props?.label}{' '}
                        {props.data.structure.required && <span className="required">*</span>}
                    </label>
                )}

                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement="top" arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>

            <div className="form-addTicket-input">
                {/* Box show diagram mermaid */}
                <Box style={{ display: showBoxDiagram ? 'block' : 'none' }}>
                    <Box display="inline-flex" sx={{ width: '100%' }}>
                        {showBoxDiagram && <MermaidDiagram disabled={isNotEditMermaid} code={valueMermaid} id={props?.name} />}

                        {!isNotEditMermaid && (
                            <div>
                                <Button
                                    className="button-mermaid cursor-default"
                                    style={{ paddingRight: '0px' }}
                                >
                                    <img
                                        src="/assets/image/button-url-edit.svg"
                                        alt=""
                                        className="cursor-pointer"
                                        onClick={handleOnclickEdit}
                                    />
                                </Button>
                            </div>
                        )}
                    </Box>
                </Box>

                {/* Box input mermaid */}
                <Box style={{ display: !showBoxDiagram ? 'block' : 'none' }}>
                    <Box display="flex" sx={{ width: '100%' }}>
                        <Box sx={{ flexGrow: 1, paddingRight: '10px' }}>
                            <FormInputWithOnChange
                                name={props?.name}
                                className="form-control form-control-wrapTextarea form-control-hg200"
                                variant="outlined"
                                defaultValue={valueMermaid}
                                value={valueMermaid}
                                multiline
                                disabled={isNotEditMermaid}
                                errorlist={props?.errorlist}
                                autoComplete="off"
                                required={props?.required}
                                onChange={onChangeValueMermaidInput}
                                data-cy="text-area-input-field"
                                isDisableOnBlur={
                                    props.isDisableOnBlur ? props.isDisableOnBlur : true
                                }
                            />
                        </Box>
                        <Box display="inline-flex" alignItems="flex-start">
                            <Button className="button-mermaid cursor-default">
                                <img
                                    src="/assets/image/button-url-apply.svg"
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={handleOnApply}
                                />
                            </Button>
                            <Button
                                className="button-mermaid cursor-default"
                                style={{ paddingRight: '0px' }}
                            >
                                <img
                                    src="/assets/image/button-url-reset.svg"
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={handleOnReset}
                                />
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </div>
        </div>
    );
}
